export interface IApiProspectsSummaryCount {
  RecentViews?: number;
  ThisMonthViews?: number;
  FavoritedMe?: number;
  IHaveFavorited?: number;
  Matches?: number;
  LikedMe?: number;
  ILiked?: number;
}

export default class DateFinderCount {
  recentViews: number;
  thisMonthViews: number;
  favoritedMe: number;
  haveFavourited: number;
  matches: number;
  likedMe: number;
  iLiked: number;

  constructor() {
    this.recentViews = 0;
    this.thisMonthViews = 0;
    this.favoritedMe = 0;
    this.haveFavourited = 0;
    this.matches = 0;
    this.likedMe = 0;
    this.iLiked = 0;
  }

  static mappingPropertyObject(object: IApiProspectsSummaryCount): DateFinderCount {
    const newObject = new DateFinderCount();
    newObject.recentViews = object.RecentViews || 0;
    newObject.thisMonthViews = object.ThisMonthViews || 0;
    newObject.favoritedMe = object.FavoritedMe || 0;
    newObject.haveFavourited = object.IHaveFavorited || 0;
    newObject.matches = object.Matches || 0;
    newObject.likedMe = object.LikedMe || 0;
    newObject.iLiked = object.ILiked || 0;

    return newObject;
  }
}
